import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import useAuthStore from './auth.store';
import { tenantApi } from '../api/tenant.api';

export interface Tenant {
  value: string;
  label: string;
}

export const ALL_TENANTS_VALUE = '';
export const TENANT_COL_KEY = 'tenant';

interface TenantStore {
  tenants: Tenant[];
  selectedTenant: string;
  isTenantLocked: boolean;
  fetchTenants: () => Promise<void>;
  setSelectedTenant: (value: string) => void;
  resetTenant: () => void;
}

const useTenantStore = create<TenantStore>()(
  persist(
    (set, get) => ({
      tenants: [],
      selectedTenant: ALL_TENANTS_VALUE,
      isTenantLocked: false,

      fetchTenants: async () => {
        const { isSuperAdmin } = useAuthStore.getState();

        if (isSuperAdmin) {
          const protoTenants = await tenantApi.listTenants();
          const tenants: Tenant[] = protoTenants.map((t) => ({ value: t.uuid, label: t.name }));
          set((state) => {
            const persistedIsValid =
              state.selectedTenant === ALL_TENANTS_VALUE || tenants.some((t) => t.value === state.selectedTenant);
            return {
              tenants,
              selectedTenant: persistedIsValid ? state.selectedTenant : ALL_TENANTS_VALUE,
              isTenantLocked: false,
            };
          });
        } else {
          const { tenantUuid } = useAuthStore.getState();
          if (!tenantUuid) return;
          const mapped: Tenant = { value: tenantUuid, label: tenantUuid };
          set({
            tenants: [mapped],
            selectedTenant: mapped.value,
            isTenantLocked: true,
          });
        }
      },

      setSelectedTenant: (value: string) => {
        if (get().isTenantLocked) return;
        set({ selectedTenant: value });
      },

      resetTenant: () => set({ tenants: [], selectedTenant: ALL_TENANTS_VALUE, isTenantLocked: false }),
    }),
    {
      name: 'tenant-storage',
      partialize: (state) => ({ selectedTenant: state.selectedTenant }),
    },
  ),
);

export default useTenantStore;
